import { render } from "./PrcHandle.vue?vue&type=template&id=2f10a477&scoped=true"
import script from "./PrcHandle.vue?vue&type=script&lang=js"
export * from "./PrcHandle.vue?vue&type=script&lang=js"

import "./PrcHandle.vue?vue&type=style&index=0&id=2f10a477&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f10a477"]])

export default __exports__